export class WidgetVelocityApi {
    constructor() {
        this._featureLookup = new Map();
    }
    isFeatureEnabled(feature) {
        if (this._featureLookup.has(feature)) {
            return this._featureLookup.get(feature);
        }
        return false;
    }
    setFeatureState(feature, isEnabled) {
        this._featureLookup.set(feature, isEnabled);
    }
}
